import { ReactComponent as CloseIcon } from '../assets/close.svg';
import { cutString } from '../../../utils/cutString';

import styles from './ItemBadge.module.scss';

interface FilterItemBadgeProps {
  name: string;
  icon?: React.ReactNode;
  onChange: () => void;
}

export const ItemBadge: React.FC<FilterItemBadgeProps> = ({name, icon, onChange}) => {
  return (
    <div className={styles.filterItemBadge} onClick={onChange} aria-label={`Remove ${name} filter`}>
      {icon && <span className={styles.badgeIcon}>{icon}</span>}
      <span className={styles.badgeName}>{name.length > 25 ? cutString(name, 25) : name}</span>
      <button className={styles.removeButton} aria-label={`Remove ${name} filter`}>
        <CloseIcon />
      </button>
    </div>
  );
};
